module.exports = __webpack_public_path__ + "bb42028dd248a485669162e62d3f7285.jpg";